import { ClaimListDetails, ClaimListRequest, ClaimListResponse } from "../modules/claim/models/claimList.models";
import { beneficiaryReqPayload } from "../modules/home/home.model";
import { ClaimIntimationResponse } from "../modules/intimation/IntimationModel";
import { LogParameter, LogRequestPayload, filterClaimListRequest } from "../modules/profile/Account.model";
import SendRequest from "../services/sendRequest.service";
import { getIpAdd, getPlatform } from "../utils/Helper";

  export const beneficiariesApi = async( ) => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/beneficiary/family`;
    const response =await SendRequest.instance.get( url );
    const logsData : LogParameter = {
      isDataLoaded : response.isSuccess,
      actionPage : 'Beneficiary_API' ,
      requestBody:"" ,
      responseBody:JSON.stringify(response),
      entityName:url,
      loginBy: `Beneficiary_${localStorage.getItem('loginBy')}`
    }
    logAPIStatus(logsData);
    return response;
  };

  export const activeClaimsApi = async() => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/claim/activeClaims`;
    const response =await SendRequest.instance.get( url);
    return response;
  };

  export const activeIntimationsApi = async() => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/claim/activeIntimations`;
    const response =await SendRequest.instance.get( url);
    return response;
  };
  
  export const intimationDetail = async ( payload: any) => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/claim/search/intimation`
    let response: ClaimIntimationResponse = await SendRequest.instance.post(
      url, payload
  );
    return response;
  };

  export const   fetchClaimListDatas = async (payload : filterClaimListRequest): Promise<ClaimListResponse> => {
    const url =`${process.env.REACT_APP_API_BASE_URL}/claimList/family`
    let response: ClaimListResponse = await SendRequest.instance.post(url , payload);
    const logsData : LogParameter = {
      isDataLoaded : response.isSuccess,
      actionPage : 'ClaimList' ,
      requestBody:JSON.stringify(payload) ,
      responseBody:JSON.stringify(response),
      entityName:url,
      claimLength: response?.searchResults?.length || null
    }
    logAPIStatus(logsData);
    return response
  }
  

export const logAPIStatus = async (logsFields: LogParameter) => {
  const ipAdd= await getIpAdd();
  const referrer=document.referrer ;
  const payload : LogRequestPayload = {
    dataLoaded: logsFields.isDataLoaded,
    actionOn: logsFields.actionPage,
    source: 'MAven',
    platform: getPlatform(),
    accessToken: localStorage.getItem('accessToken') || null ,
    requestBody: logsFields.requestBody,
    responseBody: logsFields.responseBody,
    entityName:logsFields.entityName,
    loginBy: logsFields?.loginBy,
    ipAdd : ipAdd.ip,
    referer: referrer ,
    claimLength :logsFields?.claimLength ,
    claimID: logsFields?.claimID 
  }
  const url =`${process.env.REACT_APP_API_BASE_URL}/auth/log`
  let res  = await SendRequest.instance.post(
   url , payload )
   return res;
}

export const getEcardDowanload = async() => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/claim/ecard/download`;
  const response =await SendRequest.instance.get(url);
  return response;
};